import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsPanoramaCamera extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public image: string;

  @Expose()
  public name: string;

  @Expose()
  public position: { x: number; y: number; z: number };

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
